<div class="datepicker-container" [class.open]="isOpen">
  @if (showLabel && label) {
    <label class="datepicker-label">{{ label }}</label>
  }

  <div class="datepicker-trigger" (click)="toggle()">
    <hugeicons-icon [icon]="calendarIcon" [size]="16" color="currentColor" class="calendar-icon"></hugeicons-icon>
    @if (!hasValue) {
      <span class="placeholder">{{ placeholder }}</span>
    }
    @if (hasValue) {
      <span class="selected-text">{{ displayValue }}</span>
    }
    <div class="actions">
      @if (hasValue) {
        <hugeicons-icon [icon]="closeIcon" [size]="16" color="currentColor" class="clear-btn" (click)="clearDate($event)"></hugeicons-icon>
      }
    </div>
  </div>

  @if (isOpen) {
    <div class="datepicker-dropdown" [class.open-upward]="openUpward" [class.range-mode]="rangeMode"
      [style.top.px]="dropdownTop" [style.left.px]="dropdownLeft">

      <!-- Quick ranges sidebar (range mode only) -->
      @if (rangeMode) {
        <div class="quick-ranges">
          @for (qr of quickRanges; track qr.label) {
            <button class="quick-range-btn" (click)="qr.fn()">{{ qr.label }}</button>
          }
        </div>
        <div class="range-divider"></div>
      }

      <div class="calendar-panel">
        <!-- Calendar Header -->
        <div class="calendar-header">
          <button class="nav-btn" (click)="prevMonth($event)">
            <hugeicons-icon [icon]="arrowLeftIcon" [size]="20" color="currentColor"></hugeicons-icon>
          </button>
          <div class="header-selectors">
            <!-- Month selector -->
            <div class="header-select-wrapper" [class.open]="monthDropdownOpen">
              <button class="header-btn" (click)="toggleMonthDropdown($event)">
                {{ currentMonthLabel }}
                <hugeicons-icon [icon]="monthDropdownOpen ? arrowUpIcon : arrowDownIcon" [size]="14" color="currentColor"></hugeicons-icon>
              </button>
              @if (monthDropdownOpen) {
                <div class="header-dropdown">
                  @for (month of months; track month; let i = $index) {
                    <div class="header-dropdown-item"
                      [class.active]="i === currentMonth.getMonth()"
                      [class.disabled]="isMonthDisabled(i)"
                      (click)="selectMonthFromDropdown(i, $event)">
                      {{ month }}
                    </div>
                  }
                </div>
              }
            </div>
            <!-- Year selector -->
            <div class="header-select-wrapper" [class.open]="yearDropdownOpen">
              <button class="header-btn" (click)="toggleYearDropdown($event)">
                {{ currentYearLabel }}
                <hugeicons-icon [icon]="yearDropdownOpen ? arrowUpIcon : arrowDownIcon" [size]="14" color="currentColor"></hugeicons-icon>
              </button>
              @if (yearDropdownOpen) {
                <div class="header-dropdown year-dropdown" #yearDropdownEl>
                  @for (year of allYears; track year) {
                    <div class="header-dropdown-item"
                      [class.active]="year === currentMonth.getFullYear()"
                      [class.disabled]="isYearDisabled(year)"
                      (click)="selectYearFromDropdown(year, $event)">
                      {{ year }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <button class="nav-btn" [class.disabled]="isNextMonthDisabled()" (click)="nextMonth($event)">
            <hugeicons-icon [icon]="arrowRightIcon" [size]="20" color="currentColor"></hugeicons-icon>
          </button>
        </div>

        <!-- Range instruction hint -->
        @if (rangeMode) {
          <div class="range-hint">
            @if (!rangeStart) { Click to select start date }
            @else if (!rangeEnd) { Now click an end date }
          </div>
        }

        <!-- Calendar Grid -->
        <div class="calendar-grid" [class.range-grid]="rangeMode">
          @for (day of daysOfWeek; track day) {
            <div class="weekday">{{ day }}</div>
          }
          @for (date of calendarDays; track date) {
            <div class="day"
              [class.empty]="!date"
              [class.today]="isToday(date)"
              [class.selected]="!rangeMode && isSelected(date)"
              [class.range-start]="rangeMode && isRangeStart(date)"
              [class.range-end]="rangeMode && isRangeEnd(date)"
              [class.in-range]="rangeMode && isInRange(date)"
              [class.highlighted]="isHighlighted(date)"
              [class.disabled]="isDateDisabled(date)"
              (click)="date && selectDate(date)"
              (mouseenter)="onDayHover(date)"
              (mouseleave)="onDayHover(null)">
              {{ date ? date.getDate() : '' }}
              @if (isHighlighted(date)) {
                <span class="day-dot"></span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
